import * as types from '../actions/types'
import { validateEmail } from '../../utils/validations'

const initState = {
  value: '',
  isValid: false,
  showValidationResult: false,
  validationMessages: [],
}

const email = (state = initState, action) => {
  switch (action.type) {
    case types.UPDATE_CUSTOMER_LOGIN_EMAIL_FIELD:
    case types.UPDATE_CUSTOMER_FORGOT_PASSWORD_EMAIL_FIELD:
      return validateEmail(action.email)
    case types.CLOSE_CUSTOMER_FORGOT_PASSWORD_MODAL:
    case types.RESET_FORM_FEILDS:
    case types.RESET_FORGETPWD_FEILDS:
      return initState
    case types.SET_USER_DEFAULT_EMAIL:
      return {
        ...state,
        ...validateEmail(action.payload),
        value: action.payload,
      }
    default:
      return state
  }
}

export default email
